// 时间格式
export const TimeFormatType = {
    date_no_year: "MM-DD",
    date: "YYYY-MM-DD",
    month: "YYYY-MM",
    time: "YYYY-MM-DD HH:mm:ss",
    ch_date_no_year: "MM月DD日",
    ch_date: "YYYY年MM月DD日",
    date_no_split: "YYYYMMDD",
    time_xg: "YYYY/MM/DD HH:mm",
    month_no_split: "YYYYMM",
    date_xg: "YYYY/MM/DD",
    date_point: "YYYY.MM.DD",
}

// 文本短信签名类型
export const TextCategory = "Text";
// 垃取待审核列表的状态
export const AuditingStatus = ["Init", "Auditing"];

// 短信状态，签名和短信模版通用
export const UsmsStatus = {
    Init: "初始状态",
    Auditing: "审核中",
    AuditSuccess: "审核通过",
    AuditFailed: "审核未通过",
    Disable: "禁用",
    // Delete: "删除"
}
// 签名状态Badge颜色标识
export const UsmsStatusStyle = {
    Init: "a-blue",
    Auditing: "a-blue",
    AuditSuccess: "u-green",
    AuditFailed: "u-red",
    Disable: "u-gray",
    Delete: "u-gray"
}

// 短信类型
export const UsmsType = {
    Text: "文本短信",
    Video: "视频短信"
}
// 签名用途
export const SignaturePurpose = {
    Owner: "自用",
    Other: "他用"
}
// 签名类型
export const SignatureType = {
    Company: "公司",
    Application: "APP",
    Websites: "网站",
    Applet: "公众号/小程序",
    Brand: "商标",
    Government: "政府/机关事业单位/其他机构"
}

// 前端分页或下载时最大条数
export const MaxPage = 9999;

// 短信类型
export const Purpose = {
    Auth: "验证码",
    Notify: "通知",
    Sale: "营销",
    All: "通用",
}

export const SmsTypeOfBillConfig = {
  1: '验证码',
  2: '通知短信',
  3: '营销短信',
  4: '验证码&通知',
  5: 'ALL',
};

// 数值对应的短信类型
export const PurposeNumber = {
    1: "验证码",
    2: "通知短信",
    3: "营销短信",
}
// 短信类型数值型与字符串型对应关系
export const PurposeToInt = {
  Auth: 1,
  Notify: 2,
  Sale: 3,
};
// 套餐包状态
export const PackageStatus = {
  Enable: "Enable",
  Disable: "Disable"
};
export const PackageSmsStatus = {
  Valid: "有效",
  NoBalance: "额度用尽",
  Expired: "过期",
  Freezed: "冻结",
  Deleted: "已删除",
  Refunded: "已退款",
};
// 短信类型(适配控制台)
export const ConsolePurpose = {
  Auth: "验证通知",
  Sale: "营销",
  All: "通用",
};

// 短信签名模版审核结果可选状态
export const UsmsAuditStatus = {
    Auditing: "审核中",
    AuditSuccess: "通过",
    AuditFailed: "未通过",
    Disable: "禁用",
}

// 发送记录的发送结果
export const ReceiptResult = {
    SendSuccess: "发送成功",
    SendFailed: "发送失败",
    UnKnown: "未知状态",
    CommitFailed: "提交失败",
}

// 发送结果Badge颜色标识
export const ReceiptResultStyle = {
    SendSuccess: "u-green",
    SendFailed: "u-red",
    UnKnown: "u-orange",
    CommitFailed: "u-red"
}

// 发送检测工具使用的签名和模版
export const SendSigContent = "USMS发送检测"
export const SendTemplateId = "UTN210430824A84"

// 发送检测工具使用yonge.li账号的API key
export const PublicKey = "4ZDuh4sgF2m5Ub8BxrGfkK2T0OcJFB9FT";
export const PrivateKey = "12WkwB6VGxr6qYOPEmzfys2zUqt7O5ZNDIlEG2JerMbl";

// 提交结果成功标识（后端确认所有成功都为0）
export const SubmitResultSuccess = "0"

// 国内外
export const DomesticFlag = {
    Domestic: "国内",
    Foreign: "国外",
}

export const ForeignFlag = {
  Foreign: "国外",
}

export const DomesticKey = "Domestic"
export const ForeignKey = "Foreign"

// 国内外短信
export const CountryType = {
    Domestic: "国内短信",
    Foreign: "国际短信",
}

export const OrganizationType = {
    "channel": "渠道客户",
    "common": "直客",
}

export const ChannelOrganizationKey = "channel"
export const CommonOrganizationKey = "common";

// 渠道客户的行业ID，预发和线上不一样
// export const CHANNEL_CUSTOMER_ITID = 12 // pre
export const CHANNEL_CUSTOMER_ITID = 23 // prod

// 通道配置类型
export const ChannelType = {
  // 1: "国内通道",
  2: "海外通道",
  3: "客户通道"
};

// 主/备通道
export const ChannelReplaceType = {
  "Main": "主通道",
  "Backup": "备通道"
}

// 付费类型
export const PaidType = {
  0: "预付费",
  1: "后付费",
  2: "预充值",
};

// 通道协议类型
export const ProtoType = {
  HTTP: "HTTP",
  // CMPP: "CMPP",
  // "CMPP3.0": "CMPP3.0",
  SMPP: "SMPP",
};
export const ProtoTypeToInt = {
  HTTP: 0,
  CMPP: 1,
  SMGP: 2,
  SGIP: 3,
  "CMPP3.0":4,
  SMPP:5
};

// 运营商
export const AllOperatorType = {
  all: "全部",
  // cmcc: "中国移动",
  // cucc: "中国联通",
  // ctcc: "中国电信",
  // province: "分省",
};

// 操作日志的类型-新增
export const RecordCreateType = 1;
// 操作日志的类型-删除
export const RecordDeleteType = 2;
// 操作日志的类型-修改
export const RecordUpdateType = 3;

export const RecordTypeId = {
  ChannelConfig: 2, // 通道调度
  Channel: 3, // 通道管理
  CustomerBillConfig: 12, // 客户计费配置
}

// 风险标识
export const RiskTagName = {
  1: '高风险',
  2: '关联公司高风险',
  3: '新注册'
}

// 升级、未升级
export const UpgradeStatus = {
  All: "全部",
  Enable: "已升级",
  Disable: "未升级",
}

export const SmsTypeToPurpose = {
  1: [1],
  2: [2],
  3: [3],
  4: [1, 2],
  5: [1, 2, 3],
};

export const ChargeTypeEnum = {
  2: '按月',
  3: '按年',
  101: '按量',
  102: '后付费',
  203: '实时扣费',
};

export const ChargeTypeReverseEnum = {
  按月: 2,
  按年: 3,
  按量: 101,
  后付费: 102,
  实时扣费: 203,
};

export const BillType = {
  1: '默认销售价/内部结算价配置',
  2: '特殊销售价/内部结算价配置',
};

export const ForeignDefaultBillConfigDiscount = {
  MinDiscount: 80,
  SettlementPriceDiscount: 80,
};

export const USpeedoUserType = {
  CustomAgent: 4, // WhatsApp 代理用户
};

// 数值对应的短信类型
export const CustomerSMSPurpose = {
  0: '国外(ALL)',
  1: '验证码',
  2: '通知短信',
  3: '营销短信',
};

export const WalletRechargeStatus = {
  0: '待确认',
  1: '已确认',
  2: '已取消',
  3: '充值处理中',
  4: '充值成功',
  5: '充值失败',
};

export const WalletRechargeStatusBadge = {
  0: '#bfbfbf', // 灰色
  1: '#1890ff', // 蓝色
  2: '#ff4d4f', // 红色
  3: '#faad14', // 橙色
  4: '#52c41a', // 绿色
  5: '#fa541c', // 火山色
};

export const WalletRechargeMap = {
  1: '确认充值',
  2: '取消充值',
};